export default "__VITE_ASSET__B9pqvKv3__"